import axios from 'axios';

const PortalStudentSubscription = {
    namespaced: true,
    actions: {     
       
         InitiatePayment({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalStudentSubscription/InitiatePayment`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },              
        VerifyPayment({ rootState },TransactionRef) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalStudentSubscription/VerifyPayment?TransactionRef=${TransactionRef}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },  
                 
    }
}

export default PortalStudentSubscription